export const CUSTOMER_SITE_PROXY_URL =
  process.env.REACT_APP_CUSTOMER_SITE_PROXY_URL || "http://localhost:3000";

export const CUBE_JS_PROXY_URL =
  process.env.REACT_APP_CUBE_JS_PROXY_URL ||
  "http://localhost:4000/cubejs-api/v1";
